import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useLang } from "@/lib/i18n";
import { Sparkles, Coins, LogOut, History, User, Globe, Wand2 } from "lucide-react";

export default function CustomerHeader() {
  const { user, logout } = useAuth();
  const { lang, changeLang, languages } = useLang();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 glass-strong">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <Link to={user?.role === "falci" ? "/falci-panel" : "/panel"} data-testid="header-logo" className="flex items-center gap-2">
          <Sparkles className="w-6 h-6 text-[#D4AF37]" />
          <span className="font-serif-myst text-2xl font-semibold tracking-tight">FalZilla</span>
        </Link>

        <nav className="flex items-center gap-1.5 sm:gap-2">
          <div className="relative group">
            <button className="btn-ghost px-2.5 py-1.5 rounded-full text-xs flex items-center gap-1" data-testid="nav-lang">
              <Globe className="w-3.5 h-3.5" /><span className="hidden sm:inline uppercase">{lang}</span>
            </button>
            <div className="absolute right-0 top-full mt-1 glass rounded-xl overflow-hidden opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-opacity min-w-[120px] z-50">
              {languages.map((l) => (
                <button key={l.code} onClick={() => changeLang(l.code)} data-testid={`lang-opt-${l.code}`}
                  className={`w-full text-left px-3 py-2 text-xs hover:bg-white/5 ${lang === l.code ? "gold-text" : "text-white/70"}`}>
                  {l.name}
                </button>
              ))}
            </div>
          </div>
          {user && (
            <>
              {user.role !== "falci" && (
                <Link to="/fal-bakmak-ister-misin" data-testid="nav-falci-apply" className="btn-ghost px-3 py-1.5 rounded-full hidden md:flex items-center gap-1.5 text-xs gold-text">
                  <Wand2 className="w-3.5 h-3.5" /> Fal bak, kazan
                </Link>
              )}
              {user.role === "falci" && (
                <Link to="/falci-panel" data-testid="nav-falci-panel" className="btn-ghost px-3 py-1.5 rounded-full flex items-center gap-1.5 text-sm gold-text">
                  <Wand2 className="w-3.5 h-3.5" /> <span className="hidden sm:inline">Falcı Paneli</span>
                </Link>
              )}
              <Link to="/magaza" data-testid="nav-store" className="token-pill px-3 py-1.5 rounded-full flex items-center gap-1.5 text-sm">
                <Coins className="w-4 h-4" />
                <span data-testid="token-balance">{user.tokens}</span>
              </Link>
              <Link to="/gecmis" data-testid="nav-history" className="btn-ghost px-3 py-1.5 rounded-full hidden sm:flex items-center gap-1.5 text-sm">
                <History className="w-4 h-4" />
              </Link>
              <Link to="/profil" data-testid="nav-profile" className="btn-ghost px-3 py-1.5 rounded-full flex items-center gap-1.5 text-sm">
                <User className="w-4 h-4" />
                <span className="hidden sm:inline">{user.name.split(" ")[0]}</span>
              </Link>
              <button data-testid="nav-logout" onClick={() => { logout(); navigate("/"); }} className="btn-ghost px-3 py-1.5 rounded-full text-sm" aria-label="Çıkış">
                <LogOut className="w-4 h-4" />
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
